'use client';

import { useState, useEffect, useCallback } from 'react';

interface DynamicLinkProps {
  getHref: () => string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

/**
 * A link component that computes its href client-side only.
 * This avoids React hydration errors when the href depends on
 * client-side values like window.location.hostname.
 *
 * Uses "#" as placeholder during SSR to ensure consistent rendering.
 */
export function DynamicLink({ getHref, className, children, onClick }: DynamicLinkProps) {
  const [href, setHref] = useState('#');

  // Memoize getHref to avoid infinite loops
  const computeHref = useCallback(getHref, [getHref]);

  useEffect(() => {
    setHref(computeHref());
  }, [computeHref]);

  return (
    <a href={href} className={className} onClick={onClick}>
      {children}
    </a>
  );
}
